module.exports = __webpack_public_path__ + "img/comm_14.1ce0d025.jpg";